module.exports = __webpack_public_path__ + "img/FORWARD.30b75a7d.png";